document.addEventListener('DOMContentLoaded', (event) => {
const boxes = gsap.utils.toArray('.custom-fade-in');

boxes.forEach((box, i) => {
  const anim = gsap.fromTo(box, {autoAlpha: 0, y: 20}, {duration: 0.5, autoAlpha: 1, y: 0});
  ScrollTrigger.create({
    trigger: box,
    animation: anim,
    toggleActions: 'play play play play',
    once: false,
  });
});
});